import React, { Component } from 'react'
import { tokenStorage } from '@atheneum/api/dist/lib'
import PropTypes from 'prop-types'

import WidgetBox from '../WidgetBox'
// Icons
import GetAppIcon from '@material-ui/icons/GetApp'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import _ from 'lodash'
import CopyButton from '@components/CopyButton'
class WebExtensions extends Component {
  static propTypes = {
    extensionInfo: PropTypes.object,
    userStore: PropTypes.object
  }
  render() {
    const { extensionInfo, userStore } = this.props

    const token = tokenStorage.get()

    const linkedInExtensionInstructionsLink =
      'https://atheneumpartners.sharepoint.com/sites/digitalization/SitePages/Chrome-Extension---Sales-Navigator-to-Atheneum-Platform.aspx'

    const employeeID = _.get(userStore, 'user.employee.id')
    const expertComplianceReferralLink = `https://atheneum.ai/expert-compliance/${employeeID}`

    return (
      <WidgetBox label="Web Links" theme="blue">
        <div className="webExtensions-block">
          <span className='web-links-subtitle'>Extractors</span>
          <div className="webExtensions-heading">
            <div>Name</div>
            <div>Browser</div>
            <div>Version</div>
          </div>
          <div className="webExtensions-row">
            <div>Atheneum Contact</div>
            <div>Chrome</div>
            <div>2.7.0</div>
            <div className="webExtensions-icons">
              <a
                href={
                  'https://atheneumpartners.sharepoint.com/sites/digitalization/SitePages/Install-Atheneum-Contact.aspx?web=1'
                  // eslint-disable-next-line react/jsx-no-target-blank
                }
                className="webExtension-icon"
                target="_blank" rel="noreferrer">
                <InfoOutlinedIcon className="mobile-menu-icon" />
              </a>
              <a
                href={`${extensionInfo.contactUrl}`}
                className="webExtension-icon">
                <GetAppIcon className="mobile-menu-icon" />
              </a>
            </div>
          </div>
          <div className="webExtensions-row">
            <div>Atheneum Extractor</div>
            <div>Chrome</div>
            <div>{extensionInfo.newVersion}</div>
            <div className="webExtensions-icons">
              <a
                href={linkedInExtensionInstructionsLink}
                // eslint-disable-next-line react/jsx-no-target-blank
                target="_blank"
                className="webExtension-icon" rel="noreferrer">
                <InfoOutlinedIcon className="mobile-menu-icon" />
              </a>
              <a
                href={`${extensionInfo.newDownloadUrl}?token=${token}`}
                className="webExtension-icon">
                <GetAppIcon className="mobile-menu-icon" />
              </a>
            </div>
          </div>
        </div>
        <div className="complianceUrl-block">
          <span className="web-links-subtitle">Compliance URL</span>
          <div className="complianceUrl">
            <span>{expertComplianceReferralLink}</span>
            <div className="copy-wrapper">
              <CopyButton value={expertComplianceReferralLink} />
            </div>
          </div>
        </div>
      </WidgetBox>
    )
  }
}

export default WebExtensions
